import { flushSync } from "react-dom";
import UserNotification from "util/UserNotification";
import { loadDashboard } from "views/logic/views/Actions";
import { setIsDirty, setIsNew } from "views/logic/slices/viewSlice";
import { createView } from "views/api/views";
export default (view, history, entityShare, existingViewId) => async (dispatch) => {
  try {
    const savedView = await createView(view, entityShare, existingViewId);
    flushSync(() => {
      dispatch(setIsDirty(false));
      dispatch(setIsNew(false));
    });
    loadDashboard(history, savedView.id);
    UserNotification.success(`Saving view "${view.title}" was successful!`, "Success!");
  } catch (error) {
    UserNotification.error(`Saving view failed: ${error}`, "Error!");
  }
};
